export default __webpack_public_path__ + "static/media/excel_icon.57cd272e.png";